<template>
  <div>
    <slot name="group:title"></slot>
    <div class="grid col-span-1 gap-4 sm:grid-cols-1">
      <component
        v-for="c in components"
        :key="c.key"
        :is="c.name"
        :controls="controls"
        :value="c.value"
        :checked="c.value"
        :http-errors="c.errors"
        @on:cancel="$emit('on:cancel')"
        @on:continue="onContinue"
        @input:field="onInput($event, c.key)"
      ></component>
    </div>
  </div>
</template>

<script>
import FieldUploadImageSecondaryInsurance from "@/components/Field/OCR/UploadImageSecondaryInsurance.vue";
const FIELDS = ["upload_image_secondary_insurance"];

export default {
  components: {
    FieldUploadImageSecondaryInsurance,
  },
  props: ["controls", "errors"],
  computed: {
    fields() {
      return FIELDS;
    },
    insurances() {
      return this.$store?.state?.insurances || [];
    },
    components() {
      return this.fields.map((el) => ({
        key: el,
        name: "field-" + el.replace(/_/g, "-"),
        value: this.controls[el],
        errors: this.errors?.validation?.[`input.${el}`],
      }));
    },
  },
  methods: {
    onInput(value, key) {
      console.log(key, value)
      this.$emit("input:group", { value, key });
    },
    onContinue(data) {
      if (!data) return;

      function mapInsurance(data, insurances) {
        if (!data) return null;

        const findInsurance = insurances?.find(
          (el) => el?.name?.toLowerCase() === data?.toLowerCase()
        );

        if (findInsurance) {
          return findInsurance;
        }

        return {
          id: "other",
          name: "Other Carrier",
        };
      }

      const fieldsToEmit = [
        { key: "secondary_employer_name", value: data?.employer_name },
        { key: "secondary_plan_name", value: data?.plan_name },
        { key: "secondary_group_number", value: data?.group_number },
        { key: "secondary_home_zipcode", value: data?.home_zipcode },
        {
          key: "secondary_insurance",
          value: mapInsurance(data?.insurance_carrier_name, this.insurances),
        },
        { key: "secondary_other_insurance", value: data?.insurance_carrier_name },
        { key: "secondary_insurance_phone_number", value: data?.insurance_phone_number },
        { key: "secondary_member_id_number", value: data?.member_id_number },
        { key: "secondary_policy_holders_dob", value: data?.policy_holders_dob },
        {
          key: "secondary_policy_holders_firstname",
          value: data?.policy_holders_firstname,
        },
        {
          key: "secondary_policy_holders_lastname",
          value: data?.policy_holders_lastname,
        },
      ];

      fieldsToEmit.forEach((field) => {
        this.$emit("input:group", {
          value: field.value,
          key: field.key,
        });
      });

      // Update the store to indicate that the user has completed the OCR scan
      this.$store.commit("subFieldUpdate", {
        value: true,
        key: "didOcrSecondaryInsuranceScan",
        pKey: "meta",
      });

      // Update the store with the OCR scan result
      this.$store.commit("subFieldUpdate", {
        value: data,
        key: "secondaryInsuranceScanResult",
        pKey: "meta",
      });

      // Emit to `init.js` if the user has completed the OCR scan
      this.$emit("on:ocr_scan", {
        event: "scheduling-ocr-scan",
        type: "insurance_card",
        location: this?.controls?.locations,
        companyId: this.$store.state?.config?.companyId,
      });

      this.$emit("on:cancel");
    },
  },
};
</script>
